// Wspólny scrubbing PII dla Sentry i PostHog.
// Cel: nie wysyłać do narzędzi analitycznych e-maili, haseł ani tokenów.

const PII_KEYS = [
  'email',
  'e-mail',
  'password',
  'new_password',
  'old_password',
  'confirmpassword',
  'confirm_password',
  'token',
  'idtoken',
  'id_token',
  'access_token',
  'credential',
  'authorization',
  'auth',
  'secret',
];

const EMAIL_RE = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi;

export function scrubString(value) {
  if (typeof value !== 'string') return value;
  return value.replace(EMAIL_RE, '[email]');
}

export function scrubObject(input, depth = 0) {
  if (input == null || depth > 5) return input;
  if (typeof input === 'string') return scrubString(input);
  if (typeof input !== 'object') return input;
  if (Array.isArray(input)) return input.map((v) => scrubObject(v, depth + 1));

  const out = {};
  for (const key of Object.keys(input)) {
    if (PII_KEYS.includes(key.toLowerCase())) {
      out[key] = '[redacted]';
    } else {
      out[key] = scrubObject(input[key], depth + 1);
    }
  }
  return out;
}

// beforeSend dla Sentry — czyści message, request, extra, breadcrumbs i usuwa user.email/ip.
export function sentryBeforeSend(event) {
  try {
    if (event.message) event.message = scrubString(event.message);
    if (event.request && event.request.data) {
      event.request.data = scrubObject(event.request.data);
    }
    if (event.extra) event.extra = scrubObject(event.extra);
    if (Array.isArray(event.breadcrumbs)) {
      event.breadcrumbs = event.breadcrumbs.map((b) => ({
        ...b,
        message: b.message ? scrubString(b.message) : b.message,
        data: b.data ? scrubObject(b.data) : b.data,
      }));
    }
    if (event.user) {
      delete event.user.email;
      delete event.user.ip_address;
    }
  } catch (e) {
    // Nigdy nie blokujemy wysyłki błędu z powodu scrubbingu.
  }
  return event;
}

// sanitize_properties dla PostHog.
// UWAGA: posthog-js trzyma klucz projektu w properties.token i dopiero potem
// przepuszcza properties przez tę funkcję. Zredagowanie 'token' = event z
// nieprawidłowym kluczem API, odrzucany po stronie ingestu. Klucze zastrzeżone
// biblioteki muszą przejść nietknięte.
const POSTHOG_RESERVED_KEYS = ['token', 'distinct_id'];

export function posthogSanitizeProperties(properties) {
  const cleaned = scrubObject(properties);
  if (properties && cleaned) {
    for (const key of POSTHOG_RESERVED_KEYS) {
      if (key in properties) cleaned[key] = properties[key];
    }
  }
  return cleaned;
}
